import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss']
})
export class TextareaInputComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  subTitle: string;

  @Input()
  value: string;

  @Input()
  placeholder: string = "";

  @Output()
  valueChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  updateValue(value: string): void {
    this.value = value;
    this.valueChanged.emit(this.value);
  }

}
